export const FETCH_FORMS = 'findVAForms/FETCH_FORMS';
export const FETCH_FORMS_FAILURE = 'findVAForms/FETCH_FORMS_FAILURE';
export const FETCH_FORMS_SUCCESS = 'findVAForms/FETCH_FORMS_SUCCESS';
export const FETCH_FORMS_SUCCESS_NO_RESULTS =
  'findVAFORMS/FETCH_FORMS_SUCCESS_NO_RESULTS';
export const UPDATE_PAGINATION = 'findVAForms/UPDATE_PAGINATION';
export const FAF_OPTION_CLOSEST_MATCH = 'Closest match';
export const FAF_SORT_OPTIONS = [
  'Closest match',
  'Ascending (A-Z)',
  'Descending (Z-A)',
  'Last updated (newest)',
  'Last updated (oldest)',
];
export const INITIAL_SORT_STATE = 'Closest match';
export const FORM_MOMENT_CONSTRUCTOR_DATE_FORMAT = 'yyyy-mm-dd';
export const FORM_MOMENT_PRESENTATION_DATE_FORMAT = 'MMMM yyyy';
export const UPDATE_HOW_TO_SORT = 'findVAForms/UPDATE_HOW_TO_SORT';
export const UPDATE_RESULTS = 'findVAForms/UPDATE_RESULTS';
export const MAX_PAGE_LIST_LENGTH = 10;
